import React from 'react';

import Modal from '../../../../../../components/Modal/Modal';
import Section from '../../../../../../components/outline/Section';
import TableWithSummary from '../../../../../../components/table/TableWithSummary';
import { COUPON_LIST_FILTER_OPTION_MODEL } from '../../../../../../store/modules/coupon/models';
import { LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import { COUPON_LIST_TABLE_EMPTY_TEXT } from '../../../../../../constants/service/app/couponConstants';
import columns from './columns';

const GenerateCouponUserDetailModalView = (props) => {
  const {
    isOpen = true,
    closeModal,
    list,
    filterOption,
    pagination,
    sortOption,
    totalCnt,
    onSubmit,
    onCheckIssuedCoupon,
    handleIssuedCount,
    getList,
    selectedCouponList,
    toggleModal,
    getExcelDownload,
  } = props;

  return (
    <Modal
      title="발급할 쿠폰 선택"
      isOpen={isOpen}
      width={1500}
      height={600}
      isFooter={true}
      okText="발급하기"
      onOk={onSubmit}
      onClose={closeModal}
    >
      <Section className="coupon-generate-modal" title="[발급할 쿠폰을 선택해주세요.]">
        <div className="info">
          선택된 쿠폰: <span>{selectedCouponList.length}개</span>
        </div>

        <TableWithSummary
          data={list}
          totalCnt={totalCnt}
          initialOption={{
            filterOption: COUPON_LIST_FILTER_OPTION_MODEL,
            pagination: LIST_PAGINATION_MODEL,
          }}
          isStriped={true}
          emptyText={COUPON_LIST_TABLE_EMPTY_TEXT}
          showPagination
          sortOption={sortOption}
          filterOption={filterOption}
          pagination={pagination}
          getList={getList}
          isUsedCheckbox={true}
          getExcelDownload={getExcelDownload}
          checkedIdList={selectedCouponList}
          onCheck={(list) => onCheckIssuedCoupon(list)}
          maxHeight={500}
          columns={(utils) =>
            columns({
              list,
              selectedCouponList,
              onChangeIssuedCount: handleIssuedCount,
              toggleModal,
              ...utils,
            })
          }
        />
      </Section>
    </Modal>
  );
};

export default GenerateCouponUserDetailModalView;
